import { render, staticRenderFns } from "./Attribution.vue?vue&type=template&id=173ecf68&scoped=true"
import script from "./Attribution.vue?vue&type=script&lang=js"
export * from "./Attribution.vue?vue&type=script&lang=js"
import style0 from "./Attribution.vue?vue&type=style&index=0&id=173ecf68&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "173ecf68",
  null
  
)

export default component.exports